export interface PossibleTypesResultData {
  possibleTypes: {
    [key: string]: string[];
  };
}
const result: PossibleTypesResultData = {
  possibleTypes: {
    LeaderboardUnion: [
      "BestBallLeaderboard",
      "GolfLeaderboard",
      "PolfLeaderboard",
      "ScrambleLeaderboard",
      "SegmentedLeaderboard",
    ],
    PolfEventPlayerPaymentUnion: [
      "PolfEventPlayerOtherPayment",
      "VippsPayment",
    ],
  },
};
export default result;
